import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Button, Typography, TextField, Alert, FormControlLabel, Checkbox, Link } from '@mui/material';
import GenericForm from './GenericForm';
import { businessFormFields as staticBusinessFields } from '../forms/businessFormFields';

export const BusinessForm = ({ onRegisterSuccess }) => {
  const [formData, setFormData] = useState({ acceptedTerms: false });
  const [error, setError] = useState('');
  const [businessFields, setBusinessFields] = useState(staticBusinessFields);

  useEffect(() => {
    // Carica le categorie all'avvio del form
    const loadCategories = async () => {
      try {
        const res = await axios.get('/api/categories');
        const categories = res.data;
        // Aggiorna i field con le categorie caricate
        const updatedFields = staticBusinessFields.map(field => {
          if (field.name === 'categories') {
            return { ...field, options: categories };
          }
          return field;
        });
        setBusinessFields(updatedFields);
      } catch (err) {
        console.error('Errore caricamento categorie:', err);
      }
    };
    loadCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validazione checkbox
    if (!formData.acceptedTerms) {
      setError('Devi accettare i Termini di Servizio e la Privacy Policy.');
      return;
    }
    
    try {
      // formData ora contiene sia i dati del GenericForm che la password
      await axios.post('/api/auth/signup/business', formData);
      onRegisterSuccess && onRegisterSuccess({ type: 'business' });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Si è verificato un errore imprevisto. Riprova.');
      }
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h6" sx={{ mb: 2 }}>Registrazione Azienda Partner</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <GenericForm
        fields={businessFields}
        formData={formData}
        setFormData={setFormData}
      />

      {/* La password viene gestita a parte */}
      <TextField
        sx={{ mt: 2 }}
        name="password"
        label="Password"
        type="password"
        // 👇 CORREZIONE: Aggiunta la prop 'value' per renderlo un componente controllato
        value={formData.password || ''} 
        onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
        fullWidth
        required
      />
      
      <FormControlLabel
        sx={{ mt: 2 }}
        control={
          <Checkbox
            checked={formData.acceptedTerms}
            onChange={(e) => setFormData(prev => ({ ...prev, acceptedTerms: e.target.checked }))}
          />
        }
        label={
          <Typography variant="body2">
            Accetto i{' '}
            <Link href="/privacy-terms" target="_blank" rel="noopener noreferrer" sx={{ color: '#417a2a' }}>
              Termini di Servizio e Privacy Policy
            </Link>
          </Typography>
        }
      />
      
      <Button type="submit" variant="contained" fullWidth size="large" sx={{ mt: 2 }}>
        Invia per Approvazione
      </Button>
    </Box>
  );
};